import type { SxProps, Theme } from '@mui/material'

export const infoContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  mt: 1,
}

export const infoRowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  gap: 1,
}

export const labelSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '0.75em',
  color: 'text.secondary',
  flexShrink: 0,
}

export const patternValueSx = (theme: Theme): SxProps<Theme> => ({
  fontFamily: 'monospace',
  fontSize: '0.875em',
  color: theme.palette.mode === 'dark' ? theme.palette.error.light : theme.palette.error.main,
  wordBreak: 'break-all',
})

export const pathValueSx = (theme: Theme): SxProps<Theme> => ({
  fontFamily: 'monospace',
  fontSize: '0.875em',
  color: theme.palette.primary.main,
  wordBreak: 'break-all',
})
